const zh = {
  workDoing: '施工中',
  shutdown: '停工中',
  finish: '竣工',
  undefined: '未定义',
  projectIntro: '项目简介',
  projectInfo: '项目信息',
  address: '地址',
  manager: '管理员',
  telephone: '电话',
  safetyOfficer: '安全总监',
  constructionUnit: '施工单位',
  overview: '概览',
  craneTotal: '塔吊总数',
  onlineTotal: '在线总数',
  antiDevice: '防碰撞设备',
  videoDevice: '一体机设备',
  alarmMonitor: '报警监控',
  alarmDetail: '报警详情',
  peccancyDetail: '违章详情',
  todayStatistics: '今日统计',
  todayOnlineRate: '今日在线率',
  dayToDay: '日环比',
  todayAlarm: '今日报警',
  times: '次',
  craneAvg: '塔均',
  todayPeccancy: '今日违章',
  todayHoisting: '今日吊次',
  todayHours: '今日工时',
  alarmRanking: '今日报警排名',
  alarm: '报警',
  overLimit: '违章',
  craneInfo: '塔机信息',
  craneName: '塔机',
  type: '类型',
  flatTop: '平臂',
  luffing: '动臂',
  hammerhead: '塔头',
  towerCraneHeight: '塔高',
  jibLength: '起重臂',
  balanceLength: '平衡臂',
  sectionHeight: '标准节高',
  ratedLoad: '额定吊重',
  factory: '厂商',
  model: '型号',
  companyName: '北京萨达智能技术有限公司',
  mainHook: '主钩',
  jib: '前桥',
  balance: '后桥',
  cabin: '驾驶舱',
  panorama: '全景',
  title: '塔机3D监控大屏',
  introduce: '助力施工现场塔机安全管理',
  username: '账号',
  password: '密码',
  rememberPwd: '记住密码',
  login: '登录',
  open: '开',
  close: '关',
  radius: '幅度',
  slewing: '回转',
  hook: '吊钩',
  load: '吊重',
  torque: '力矩比',
  safetyLoad: '安全吊重',
  windSpeed: '风速',
  runTime: '运行时间',
  leftAntiCollision: '左转防碰撞',
  rightAntiCollision: '右转防碰撞',
  radiusOutAntiCollision: '幅度出防碰撞',
  radiusInAntiCollision: '幅度进防碰撞',
  leftSwingZoning: '左转限制区',
  rightSwingZoning: '右转限制区',
  radiusOutZoning: '幅度出限制区',
  radiusInZoning: '幅度进限制区',
  leftLimit: '左转限位',
  rightLimit: '右转限位',
  radiusOutLimit: '幅度出限位',
  radiusInLimit: '幅度进限位',
  heightUpLimit: '高度上限位',
  heightDownLimit: '高度下限位',
  force: '力',
  loadMoment: '力矩',
  windowSpeed: '风速',
  mainHookVideo: '主钩视频',
  jibVideo: '前桥视频',
  balanceVideo: '后桥视频',
  cabinVideo: '驾驶舱视频',
  panoramaVideo: '全景视频',
  interUserName: '请输入账号',
  interPwd: '请输入密码',
  interTitle: '提示',
  interProjectAccount: '请输入项目账号!',
  current: '电流',
  temperature: '温度',
  overload: '过载',
  smoke: '烟感',
  overhead: '高温',
  disconnect: '断开',
  blackout: '断电',
  leakage: '漏电',
  resi: '接地',
  branch: '分路',
  totalEnergy: '总电量',
  powerUnit: '度',
  resiValue: '接地阻值',
  box: '配电箱',
  noData: '无'
}
export default zh



// WEBPACK FOOTER //
// ./src/i18n/zh.js